import { getHostName } from './getHostName';
export function isEditorxDomain() {
    return getHostName().match(/editorx\.com$/);
}
//# sourceMappingURL=isEditorxDomain.js.map